function Style() {
  return (
    <div className="line-style">
      <div id="line"></div>  
    </div> 
  );
}
export default Style;